const STATES = {
  initial: "initial",
  options: "options",
  success: "success",
  error: "error",
};

class QuickBuy extends HTMLElement {
  constructor() {
    super();

    this.hasDelay = this.hasAttribute("data-delay");

    this.addEventListener("click", (e) => {
      if (e.target.closest("[data-quick-buy-trigger]")) {
        const options = this.querySelectorAll("[data-quick-buy-option]");
        if (options.length === 1) {
          this.finalSale = options[0].hasAttribute("data-final-sale")
            ? true
            : false;
          this._add(parseInt(options[0].dataset.quickBuyOption, 10));
        } else {
          this.state = STATES.options;
          window.requestAnimationFrame(() => {
            this.querySelector(
              "[data-quick-buy-option]:not(:disabled)",
            ).focus();
          });
        }

        return;
      }

      if (e.target.closest("[data-quick-buy-option]")) {
        this.finalSale = e.target
          .closest("[data-quick-buy-option]")
          .hasAttribute("data-final-sale")
          ? true
          : false;
        this._add(
          parseInt(
            e.target.closest("[data-quick-buy-option]").dataset.quickBuyOption,
            10,
          ),
        );
        return;
      }
    });

    document.addEventListener("upsell:initial", () => {
      this.state = STATES.initial;
    });
  }

  connectedCallback() { }

  disconnectedCallback() { }

  set state(state) {
    this.setAttribute("state", state);
  }

  get state() {
    return this.getAttribute("state");
  }

  get afterAdd() {
    return this.getAttribute("after-add");
  }

  _add(id) {
    let params = {
      id,
      quantity: 1,
    };

    if (this.finalSale) {
      params = {
        id,
        quantity: 1,
        properties: {
          "_Final Sale": true,
        },
      };
    }

    window.addToCart(
      params,
      {
        onError: () => this._handleError(),
        onAfterAdd: () => {
          if (this.afterAdd === "show-success") {
            this.state = STATES.success;

            window.setTimeout(() => {
              this.state = STATES.initial;
            }, 3000);
          } else {
            this.state = STATES.initial;
            window.requestAnimationFrame(() => {
              this.querySelector("[data-quick-buy-trigger]").focus();
              document.dispatchEvent(new CustomEvent("mini-cart:open"));
            });
          }
        },
      },
      this.hasDelay,
    );
  }

  _handleError() {
    this.state = STATES.error;

    window.setTimeout(() => {
      this.state = STATES.initial;
    }, 3000);
  }
}

if (!customElements.get("quick-buy")) {
  customElements.define("quick-buy", QuickBuy);
}
